import { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import UserService from "../../services/UserService";
import { UserShow } from "../../models/User";
import UserContext from "../../context/UserContext";

const PrivateRoutes = () => {
  const [currentUser, setCurrentUser] = useState<UserShow | null>(null);
  const [loading, setLoading] = useState(true);
  const prevLocation = useLocation();

  useEffect(() => {
    UserService.validateAccessToken()
      .then((user: UserShow) => {
        setCurrentUser(user);
        setLoading(false);
      })
      .catch(() => {
        setCurrentUser(null);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <div>Cargando...</div>; // o spinner
  }

  if (!currentUser) {
    return (
      <Navigate to={`/login?redirectTo=${prevLocation.pathname}`} replace />
    );
  }

  return (
    <UserContext.Provider value={{ user: currentUser }}>
      <Outlet />
    </UserContext.Provider>
  );
};

export default PrivateRoutes;
